export const FETCH_JOB = 'FETCH_JOB'
export const FETCH_JOB_LIST = 'FETCH_JOB_LIST'
export const FETCH_CURRENT_JOB = 'FETCH_CURRENT_JOB'
export const REMOVE_JOB = 'deleteJob'
export const FETCH_JOB_LIST_ACTION = 'getJobList'
export const FETCH_JOB_BY_ID_ACTION = 'getJobById'
export const CLEAR_JOB = 'CLEAR_JOB'
export const CLEAR_JOB_LIST = 'CLEAR_JOB_LIST'
export const FILL_SELECTED_JOB = 'FILL_SELECTED_JOB'
export const CLEAR_SELECTED_JOB = 'CLEAR_SELECTED_JOB'
